import React, { memo } from 'react';
import { TouchableOpacity, Image } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { PreviewPostCard } from '@redlink/components/molecules';
import { PreviewGalleryPostCardTextBlock } from './previewGalleryPostCardTextBlock';

export const PreviewGalleryPostCard = memo(({ compact, ...rest }) => {
  return !compact ? (
    <NormalPostCard {...rest} />
  ) : (
    <CompactPostCard {...rest} />
  );
});

const NormalPostCard = memo(
  ({
    item: { images = [], title, category, links = [] },
    smallTile,
    themeIndependent,
    style,
    onPress,
  }) => {
    const { styles } = useStyle();
    const hasLink = smallTile && links.length > 0 ? true : false;
    return (
      <PreviewPostCard
        {...{ style, onPress, images, smallTile, hasLink, themeIndependent }}
      >
        <PreviewGalleryPostCardTextBlock
          style={styles.textBlockContainer}
          categoryTitle={category?.title}
          {...{ title, smallTile, themeIndependent }}
        />
      </PreviewPostCard>
    );
  }
);

const CompactPostCard = memo(({ item: { images = [] }, style, onPress }) => {
  const { styles } = useStyle();
  return (
    <TouchableOpacity
      style={[style, styles.compactContainer]}
      activeOpacity={0.7}
      {...{ onPress }}
    >
      <Image style={styles.image} source={{ uri: images[0]?.thumbnailUrl }} />
    </TouchableOpacity>
  );
});

const useStyle = createUseStyle(({ colors, size, contentWidth }) => ({
  textBlockContainer: {
    marginHorizontal: 16,
    marginTop: 8,
    marginBottom: 16,
  },
  compactContainer: {
    borderWidth: size.galleryCompactListSeparatorSize,
    borderColor: colors.transparent,
  },
  image: {
    width: (contentWidth - 4 * (size.galleryCompactListSeparatorSize * 2)) / 3,
    height: (contentWidth - 4 * (size.galleryCompactListSeparatorSize * 2)) / 3,
  },
}));
